import axios from '@utils/axiosInstance'

const BASE = process.env.VUE_APP_BACKEND_PUBLIC_URL

const getDefaultState = () => {
  return {
    nationalities: [],
    states: [],
    /**
     * @deprecated
     * Este componente será removido en la versión 2.0.
     */
    region: {},
    municipalities: [],
    parameter: null,
    parameters: [],
    streetTypes: [],
    settlements: [],
    settlementType: {},
    settlementTypes: {},
    applicationRoles: [],
    infonavitCreditTypes: [],
    banks: [],
  }
}

export const state = getDefaultState()

export const getters = {}

export const mutations = {
  // V2
  UPDATE_NATIONALITIES(state, nationalities) {
    state.nationalities = nationalities
  },
  UPDATE_STATES(state, states) {
    state.states = states
  },
  /**
   * @deprecated
   * Este componente será removido en la versión 2.0.
   */
  UPDATE_REGION(state, region) {
    state.region = region
  },

  UPDATE_MUNICIPALITIES(state, municipalities) {
    state.municipalities = municipalities
  },
  UPDATE_SETTLEMENTS(state, settlements) {
    state.settlements = settlements
  },
  UPDATE_SETTLEMENT_TYPES(state, settlementTypes) {
    state.settlementTypes = settlementTypes
  },
  UPDATE_INFONAVIT_CREDIT_TYPES(state, infonavitCredittypes) {
    state.infonavitCreditTypes = infonavitCredittypes
  },
  UPDATE_BANKS(state, banks) {
    state.banks = banks
  },
  UPDATE_PARAMETER(state, parameter) {
    state.parameter = parameter
  },
  UPDATE_PARAMETERS(state, parameters) {
    state.parameters = parameters
  },
  UPDATE_APPLICATION_ROLES(state, applicationRoles) {
    state.applicationRoles = applicationRoles
  },
  RESET_COMMON_STATE(state) {
    Object.assign(state, getDefaultState())
  },
}

export const actions = {
  // REGIONS
  // GET

  async fetchRegionByPostalCode(store, postalCode) {
    const url = `${BASE}/mx/api/v2/regionByPostalCode/${postalCode}`
    try {
      if (postalCode) {
        const res = await axios.get(url)
        store.commit('UPDATE_REGION', res.data)
      }
    } catch (error) {
      throw new Error(`Api error occurred in ${url}`)
    }
  },

  // MUNICIPALITIES
  // GET
  async clearRegions(store) {
    store.commit('UPDATE_REGION', {})
  },

  async fetchMunicipalities(store, region) {
    let queryString = '?sort=name&page[size]=500&page[number]=1'
    if (region) {
      queryString = `${queryString}&filter[region]=${region}`
    }

    const url = `${BASE}/mx/api/v2/municipalities` + encodeURI(queryString)
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_MUNICIPALITIES', res.data)
    } catch (error) {
      throw new Error(`Api error occurred in ${url}`)
    }
  },

  /**
   * Fetchs municipalities by a given postal code.
   *
   * @param store
   * @param postalCode
   * @returns {Promise<void>}
   */
  async fetchMunicipalitiesByPostalCode(store, postalCode) {
    const url = `${BASE}/mx/api/v2/municipalities/postalcode/${postalCode}`
    try {
      if (postalCode) {
        const res = await axios.get(url)
        store.commit('UPDATE_MUNICIPALITIES', res.data)
      }
    } catch (error) {
      throw new Error(`Api error trying "municipalities/postalcode" with ${postalCode}`)
    }
  },

  /**
   * Fetchs settlements.
   *
   * @param store
   * @param municipalityId
   * @returns {Promise<void>}
   */
  async fetchSettlements(store, municipalityId) {
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/settlements/municipality/${municipalityId}`)
      store.commit('UPDATE_SETTLEMENTS', response.data)
      return response
    } catch (error) {
      throw new Error(`API Error occurred at /api/settlements/municipality/${municipalityId}.`)
    }
  },

  /**
   * Fetchs settlements by municipality and postal code.
   * payload {municipalityId: int, postalCode: string}
   *
   * @param store
   * @param payload
   * @returns {Promise<void>}
   */
  async fetchSettlementsByMunicipalityAndPostalCode(store, payload) {
    const municipalityId = payload.municipalityId
    const postalCode = payload.postalCode

    try {
      const response = await axios.get(`${BASE}/mx/api/v2/settlements/municipality/${municipalityId}/postalcode/${postalCode}`)
      store.commit('UPDATE_SETTLEMENTS', response.data)
      return response
    } catch (error) {
      throw new Error(`API Error occurred at /settlements/municipality/${municipalityId}/postalcode/${postalCode}`)
    }
  },

  /**
   * Fetchs settlement types.
   *
   * @param store
   * @returns {Promise<void>}
   */
  async fetchSettlementTypes(store) {
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/settlementTypes`)
      store.commit('UPDATE_SETTLEMENT_TYPES', response.data)
    } catch (error) {
      throw new Error('API Error occurred at /api/settlementTypes')
    }
  },

  async fetchSettlementTypeBySettlement(store, settlementId) {
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/settlementType/${settlementId}`)
      store.commit('UPDATE_SETTLEMENT_TYPES', response.data)
      return response.data
    } catch (error) {
      throw new Error('API Error occurred at /api/settlementTypeBySettlement')
    }
  },

  // STREET TYPES
  // GET
  async fetchStreetTypes(store) {
    const url = `${BASE}/mx/api/v2/streetTypes`
    try {
      const res = await axios.get(url)
      store.commit('UPDATE_STREET_TYPES', res.data)
    } catch (error) {
      throw new Error(`Api error occurred in ${url}`)
    }
  },
  // FETCH PARAMETER
  // GET
  async fetchParameterById(store, id) {
    try {
      const response = await axios.get(`${BASE}/api/v2/parameters/${id}`)
      store.commit('UPDATE_PARAMETER', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at api/v2/parameters/${id}`)
    }
  },
  async fetchParameter(store, id) {
    try {
      const response = await axios.get(`${BASE}/api/v2/parameters/${id}`)
      store.commit('UPDATE_PARAMETER', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at api/v2/parameters/${id}`)
    }
  },

  // FETCH PARAMETER BY CODE
  // GET
  async fetchParameterByCode(store, parameterCode) {
    try {
      const response = await axios.get(`${BASE}/api/v2/parameters/code/${parameterCode}`)
      store.commit('UPDATE_PARAMETER', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at api/v2/parameters/code/${parameterCode}`)
    }
  },

  // PARAMETERS
  // GET
  async fetchParameters(store) {
    const url = `${BASE}/api/v2/parameters`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_PARAMETERS', response.data)
    } catch (error) {
      throw new Error('API Error occurred at api/v2/parameters.')
    }
  },

  // ROLES
  // GET
  async fetchApplicationRoles(store) {
    const url = `${BASE}/api/v2/actor/role/roles`
    try {
      const response = await axios.get(url)
      store.commit('UPDATE_APPLICATION_ROLES', response.data)
    } catch (error) {
      throw new Error('API Error occurred at /api/v2/actor/role/roles.')
    }
  },

  // NEW PARAMETER
  // POST
  async parameterNew(store, payload) {
    try {
      return await axios.post(`${BASE}/api/v2/parameters`, payload)
    } catch (e) {
      throw Error('API Error occurred at post api/v2/parameters.')
    }
  },
  // EDIT PARAMETER
  // PATCH
  async parameterEdit(store, payload) {
    try {
      return await axios.patch(`${BASE}/api/v2/parameters/${payload.id}`, payload.command)
    } catch (e) {
      throw Error('API Error occurred at patch api/v2/parameters.')
    }
  },

  // Fiscal data
  async fetchInfonavitCredittypes(store) {
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/infonavit/creditTypes`)
      store.commit('UPDATE_INFONAVIT_CREDIT_TYPES', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at /api/infonavit/creditTypes.`)
    }
  },

  // Bank data
  async fetchBanks(store) {
    try {
      const response = await axios.get(`${BASE}/mx/api/v2/banks`)
      store.commit('UPDATE_BANKS', response.data)
    } catch (error) {
      throw new Error(`API Error occurred at /api/banks.`)
    }
  },
}
